<template>
<div class="accordion box">
  <div class="header"
    @click="expanded = !expanded">
    <span class="text">{{title}}</span>
    <font-awesome-icon class="expander"
      v-if="!expanded"
      icon="chevron-circle-down" />
    <font-awesome-icon class="expander"
      v-else
      icon="chevron-circle-up" />
  </div>
  <div class="body"
    @click="expanded = false"
    v-if="expanded">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'FAQ',
  props: ['title', 'body'],
  data() {
    return {
      expanded: false
    }
  }
}
</script>

<style>
.accordion:not(:first-child) {
  margin-top: 1em;
}

.accordion {
  border: 1px solid black;
  cursor: pointer;
}

.accordion .header {
  display: flex;
  flex-direction: row;
}

.accordion .header .text {
  flex: 1;
}

.accordion .expander {
  margin: 4px;
}

.accordion .header {
  padding: 4px;
}

.accordion .body {
  padding: 8px;
}

.accordion .body {
  margin-top: 4px;
  border-radius: 8px;

  background-color: #E6E6EA;
  color: black;
}
</style>
